import { render, staticRenderFns } from "./StaticBreadcrumbs.vue?vue&type=template&id=2972e9e1&"
import script from "./StaticBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./StaticBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports